import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { MatchState } from '../../enums/users/match-state.enum';
import { UserMatchPlayer } from './user-match-player.model';

@JsonObject('UserMatchDetail')
export class UserMatchDetail {

  @JsonProperty('match_id', Number)
  matchId: number = 0;

  @JsonProperty('match_state', Number)
  matchState: MatchState = MatchState.None;

  @JsonProperty('match_table_cost', Number)
  matchTableCost: number = 0;

  @JsonProperty('match_start_timestamp', Number)
  matchStartTimestamp: number = 0;

  @JsonProperty('match_end_timestamp', Number)
  matchEndTimestamp: number = 0;

  @JsonProperty('match_server_id', Any)
  matchServerId: string | null = null;

  @JsonProperty('users', [UserMatchPlayer])
  users: UserMatchPlayer[] = [];
}
